import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function FeaturedSections() {
  return <div className="w-full" data-id="element-24">
      {/* Featured Grid */}
      <section className="grid grid-cols-1 md:grid-cols-2 overflow-hidden" data-id="element-25">
        <motion.div initial={{
        x: -50,
        opacity: 0
      }} whileInView={{
        x: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#FDFCF0] text-[#2C2C2C] p-12 md:p-32 flex flex-col justify-center min-h-[600px]" data-id="element-26">
          <span className="section-overline" data-id="element-27">The Collection</span>
          <h2 className="mb-8" data-id="element-28">The Experience</h2>
          <p className="text-[#2C2C2C]/70" data-id="element-29">
            Immerse yourself in the world of Cork Dorx. From private cellar
            tours to sensory tasting journeys, we curate every detail to ensure
            your visit is nothing short of extraordinary.
          </p>
          <button className="border border-[#4A0E0E] text-[#4A0E0E] px-10 py-4 w-fit hover:bg-[#4A0E0E] hover:text-white rounded-full" data-id="element-30">
            Explore More
          </button>
        </motion.div>
        <div className="h-[600px] md:h-auto bg-cover bg-center" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/vrDAPSFvFWcK1bmEUT2LzF/ChatGPT_Image_Jul_1,_2026,_01_17_11_AM.png)'
      }} data-id="element-31" />
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2" data-id="element-32">
        <div className="h-[600px] md:h-auto bg-cover bg-center order-2 md:order-1" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8Tivu8uy7ucsYUQWzDKwKZ/photo_oct_23,_7_49_45_pm.jpg)'
      }} data-id="element-33" />
        <motion.div initial={{
        x: 50,
        opacity: 0
      }} whileInView={{
        x: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white text-[#2C2C2C] p-12 md:p-32 flex flex-col justify-center order-1 md:order-2 min-h-[600px]" data-id="element-34">
          <span className="section-overline" data-id="element-35">Community & Culture</span>
          <h2 className="mb-8" data-id="element-36">Interactive and Engaging Atmosphere</h2>
          <p className="text-[#2C2C2C]/70" data-id="element-37">
            Discover a vibrant space where wine culture comes alive. Our events
            and workshops are designed to be hands-on, social, and deeply
            educational, fostering a community of passionate enthusiasts.
          </p>
          <button className="border border-[#4A0E0E] text-[#4A0E0E] px-10 py-4 w-fit hover:bg-[#4A0E0E] hover:text-white rounded-full" data-id="element-38">
            Join the Community
          </button>
        </motion.div>
      </section>

      {/* Partnerships Section */}
      <section className="max-w-7xl mx-auto px-6 py-32 text-center" data-id="element-39">
        <span className="section-overline" data-id="element-40">Collaborations</span>
        <h2 className="text-[#4A0E0E] mb-6" data-id="element-41">Partner With Us</h2>
        <p className="text-[#2C2C2C]/60 max-w-2xl mx-auto mb-16 text-lg leading-relaxed" data-id="element-42">
          We are open to selective collaborations and partnership opportunities
          that align with our commitment to luxury, education, and community.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-43">
          {[{
          title: 'Hospitality & Venues',
          desc: 'Elevate your guest experience through curated wine programs and sensory journeys.',
          img: 'https://cdn.magicpatterns.com/uploads/2nsRKWkqPRdLsMSFkk8CnB/pexels-polina-kovaleva-7270303.jpg'
        }, {
          title: 'Brand Collaborations',
          desc: 'Partner with Cork Dorx for exclusive product launches and luxury brand activations.',
          img: 'https://cdn.magicpatterns.com/uploads/c5frN6f2N8bEQ9Eyd3mP9C/pexels-shvetsa-11368648.jpg'
        }, {
          title: 'Community & Events',
          desc: 'Bring people together through shared experiences centered around wine and connection.',
          img: 'https://cdn.magicpatterns.com/uploads/3V2stNpCkT5uqPJg8uvB6d/pexels-pavel-danilyuk-8775175.jpg'
        }].map((partner, idx) => <div key={idx} className="group bg-white rounded-[2rem] overflow-hidden border border-[#E6D5B8]/20 shadow-sm hover:shadow-xl transition-all duration-500" data-id="element-44">
              <div className="overflow-hidden aspect-[16/10]" data-id="element-45">
                <img src={partner.img} alt={partner.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-46" />
              </div>
              <div className="p-10" data-id="element-47">
                <h3 className="text-2xl font-serif text-[#4A0E0E] mb-4" data-id="element-48">
                  {partner.title}
                </h3>
                <p className="text-[#2C2C2C]/60 text-sm leading-relaxed mb-8" data-id="element-49">
                  {partner.desc}
                </p>
                <Link to="/contact" className="inline-block text-[#D4AF37] font-bold uppercase tracking-widest text-[10px] border-b border-[#D4AF37]/30 pb-1 hover:border-[#D4AF37] transition-all" data-id="element-50">
                  Inquire Now
                </Link>
              </div>
            </div>)}
        </div>
      </section>
    </div>;
}